import { actions as baseActions, getters as baseGetters, mutations as baseMutations, state as baseState } from "@torre-labs/feature-flag";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { ActionContext, ActionTree } from "vuex";

interface IFlag { key: string; value: unknown; variationId?: string; }
interface ISetFlagsPayload {
  user?: unknown;
  configcatService: { activeForAll(user?: unknown): Observable<IFlag[]>; };
}
export const state = () => ({ ...baseState(), ga4CaptureLobby: { value: false } as { value: boolean; variationId?: string } });
export type FeatureFlagState = ReturnType<typeof state>;
export const mutations = {
  ...baseMutations,
  setGa4CaptureLobbyFlag(currentState: FeatureFlagState, flag: { value: boolean; variationId?: string }): void {
    currentState.ga4CaptureLobby = flag;
  }
};
export const getters = {
  ...baseGetters,
  featureFlagGa4CaptureLobby: (currentState: FeatureFlagState): boolean => currentState.ga4CaptureLobby.value === true
};
export const actions: ActionTree<FeatureFlagState, unknown> = {
  ...baseActions,
  async setFlags(context: ActionContext<FeatureFlagState, unknown>, data: ISetFlagsPayload): Promise<void> {
    const baseSetFlags = baseActions.setFlags as (
      actionContext: ActionContext<FeatureFlagState, unknown>, payload: ISetFlagsPayload
    ) => Promise<void>;

    await baseSetFlags(context, {
      ...data,
      configcatService: {
        activeForAll: user => data.configcatService.activeForAll(user).pipe(tap((flags) => {
          const flag = flags.find(({ key }) => key === "ga4-capture-lobby");

          context.commit("setGa4CaptureLobbyFlag", { value: flag?.value === true, variationId: flag?.variationId });
        }))
      }
    });
  }
};
